import React, { memo } from 'react';
import { TextField } from '@material-ui/core';
import { hot } from 'react-hot-loader';

const Input = ({ value, type, label, onChange }) => {
  return (
    <TextField
      fullWidth
      label={label}
      defaultValue={value}
      type={type}
      onChange={onChange}
      margin="none"
    />
  );
};

export default memo(hot(module)(Input), () => true);
